// script added to main-product.liquid <script src="{{ 'loxa-custom-js.js' | asset_url }}" defer="defer"></script>  
(function() {
    const CONFIG = {
        debug: false, 
        maxRetries: 20, 
        proxyUrl: '/apps/proxy/multi_ai_price'
    };

    if (CONFIG.debug) console.group("🚀 Initializing Custom Loxa + Variant Observer");

    let calcTimeout;
    let previousStateString = null; 
    let currentInsuranceData = null;
    let currentCalculatedTotal = 0; 
    let observerRetries = 0;
    let isIntercepting = false;
    let hasSeenInsurancePrompt = false; 

    const getActiveVariantId = () => {
        const idInput = document.querySelector('.product-variant-id, product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
        if (idInput && idInput.value) return idInput.value;
        
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('variant')) return urlParams.get('variant');
        
        return window.ShopifyAnalytics?.meta?.selectedVariantId || null;
    };

    const getBaseProductInfo = () => {
        const config = window.bcpo_data || window.bcpo_product;
        const activeVariantId = getActiveVariantId();
        
        let baseProductId = config?.product_id || window.ShopifyAnalytics?.meta?.product?.id || "UNKNOWN_ID";
        let baseTitle = config?.product_title || window.ShopifyAnalytics?.meta?.product?.title || "Product";
        
        if (window.ShopifyAnalytics?.meta?.product?.variants && activeVariantId) {
            const activeVariant = window.ShopifyAnalytics.meta.product.variants.find(v => v.id.toString() === activeVariantId.toString());
            if (activeVariant && activeVariant.name) baseTitle = activeVariant.name;
        }

        let finalSku = String(baseProductId);
        let finalTitle = String(baseTitle);

        if (activeVariantId) finalSku += `-${activeVariantId}`;

        if (config && config.virtual_options) {
            const activeInputs = document.querySelectorAll('input[name^="properties["]:not([disabled])');
            activeInputs.forEach(input => {
                if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
                if (!input.value) return; 

                const optionName = input.name.replace('properties[', '').replace(']', '');
                const optionDef = config.virtual_options.find(o => o.title === optionName);
                
                if (optionDef) {
                    const cleanValue = String(input.value).split(' ').join('').toUpperCase();
                    finalSku += `-${cleanValue}`;
                    finalTitle += `-${input.value}`;
                }
            });
        }

        return { sku: finalSku, title: finalTitle };
    };

    const LoxaController = {
        removeWidget: function() {
            const existingWidget = document.getElementById('loxa-shopify-offer');
            if (existingWidget) existingWidget.remove();
        },

        openSidebar: function(fullData, addToCartButton, addToCartForm, bcpoForm, isSecondChance = false) {
            if (!fullData || !fullData.insurable || !fullData.active) return;
            
            hasSeenInsurancePrompt = true; 
            
            if (window.LoxaShopifyDev?.openSidebarForInsurance) {
                window.LoxaShopifyDev.openSidebarForInsurance(fullData); 
            } else if (window.LoxaShopify?.openSidebar) {
                window.LoxaShopify.openSidebar(fullData);
            }

            if (addToCartButton) {
                this.bindSidebarActions(addToCartButton, addToCartForm, bcpoForm, isSecondChance);
            }
        },

        bindSidebarActions: function(addToCartButton, addToCartForm, bcpoForm, isSecondChance) {
            let checkCount = 0;
            const checkSidebar = setInterval(() => {
                const actionsContainer = document.querySelector('.loxa-sidebar-actions');
                const addBtn = document.querySelector('.loxa-sidebar-cta');
                const removeBtn = document.querySelector('.loxa-sidebar-remove');
                const closeBtn = document.querySelector('.loxa-sidebar-close');
                
                if (actionsContainer && (addBtn || closeBtn)) {
                    clearInterval(checkSidebar);

                    if (isSecondChance) {
                        let continueBtn = document.querySelector('.loxa-sidebar-continue');
                        if (!continueBtn) {
                            continueBtn = document.createElement('button');
                            continueBtn.type = 'button';
                            continueBtn.className = 'loxa-sidebar-continue';
                            continueBtn.innerText = 'Continue without protection';
                            continueBtn.style.cssText = 'background: none; border: none; color: #666; text-decoration: underline; cursor: pointer; display: block; width: 100%; font-size: 0.9em; text-align: center; padding: 5px;';
                            
                            actionsContainer.appendChild(continueBtn);

                            continueBtn.addEventListener('click', () => {
                                const checkbox = document.getElementById('loxa-insurance-checkbox');
                                if (checkbox) checkbox.checked = false; 
                                
                                this.closeSidebar();
                                setTimeout(() => addToCartButton.click(), 150); 
                            });
                        }
                    } else {
                        const existingContinue = document.querySelector('.loxa-sidebar-continue');
                        if (existingContinue) existingContinue.remove();
                    }
                    
                    if (addBtn && !addBtn.dataset.bound) {
                        addBtn.dataset.bound = "true";
                        addBtn.addEventListener('click', () => {
                            const checkbox = document.getElementById('loxa-insurance-checkbox');
                            if (checkbox) checkbox.checked = true; 
                            this.closeSidebar(); 
                            const targetPlan = this.getSelectedSidebarPlan() || currentInsuranceData.insurances.find(p => p.default_selected) || currentInsuranceData.insurances[0];
                            this.executeCartAdd(addToCartForm, bcpoForm, addToCartButton, targetPlan);
                        });
                    }

                    if (removeBtn && !removeBtn.dataset.bound) {
                        removeBtn.dataset.bound = "true";
                        removeBtn.addEventListener('click', () => {
                            const checkbox = document.getElementById('loxa-insurance-checkbox');
                            if (checkbox) checkbox.checked = false; 
                            this.closeSidebar();
                            setTimeout(() => addToCartButton.click(), 150); 
                        });
                    }

                    if (closeBtn && !closeBtn.dataset.bound) {
                        closeBtn.dataset.bound = "true";
                        closeBtn.addEventListener('click', (e) => {
                            if (!e.isTrusted) return; 
                            this.closeSidebar();
                        });
                    }
                }
                if (checkCount++ > 20) clearInterval(checkSidebar); 
            }, 200);
        },
                
        getSelectedSidebarPlan: function() {
            if (!currentInsuranceData || !currentInsuranceData.insurances) return null;
            let selectedCode = document.querySelector('.loxa-sidebar-option.loxa-selected')?.getAttribute('data-loxa-code');
            if (!selectedCode) {
                const checkedRadio = document.querySelector('input[name="loxa-sidebar-insurance"]:checked');
                if (checkedRadio) selectedCode = checkedRadio.value;
            }
            if (selectedCode) {
                return currentInsuranceData.insurances.find(p => p.code === selectedCode) || null;
            }
            return null;
        },

        closeSidebar: function() {
            document.querySelector('.loxa-sidebar-close')?.click(); 
        },

        executeCartAdd: async function(addToCartForm, bcpoForm, addToCartButton, targetPlan) {
            isIntercepting = true;
            const spinner = addToCartButton.querySelector('.loading__spinner');
            
            try {
                addToCartButton.classList.add('loading');
                if (spinner) spinner.classList.remove('hidden');

                const insuranceVariantId = await this.findMatchingVariantId(targetPlan.insurance_price);
                
                if (!insuranceVariantId) {
                    console.error("❌ Missing matching variant.");
                    addToCartButton.click(); 
                    return;
                }

                const baseProductInfo = getBaseProductInfo(); 
                const sumInsuredRaw = currentInsuranceData.sum_insured || currentCalculatedTotal;
                const formattedSumInsured = parseFloat(sumInsuredRaw).toFixed(2);
                
                const actualCode = targetPlan.code || currentInsuranceData.code;
                const actualTerm = targetPlan.insurance_term || "N/A";
                
                const insuranceProperties = {
                    "_Premium": `£${targetPlan.insurance_price}`,
                    "Sum Insured": `£${formattedSumInsured}`,
                    "Insured Product": baseProductInfo.title, 
                    "_insuredProductId": baseProductInfo.sku, 
                    "_Category": currentInsuranceData.insurance_category || "General", 
                    "_loxaTerm": actualTerm,
                    "_Source": "online"
                };

                if (targetPlan.inclusive_insurance) {
                    insuranceProperties["_loxaInclusiveCode"] = actualCode;
                } else if (actualCode) {
                    insuranceProperties["_loxaInsuranceCode"] = actualCode;
                }

                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: insuranceVariantId, quantity: 1, properties: insuranceProperties }] })
                });

                if (response.ok) {
                    const checkbox = document.getElementById('loxa-insurance-checkbox');
                    if (checkbox) checkbox.checked = false;
                    setTimeout(() => addToCartButton.click(), 100);
                } else {
                    alert("There was an issue adding the insurance to the cart.");
                    if (spinner) spinner.classList.add('hidden');
                    addToCartButton.classList.remove('loading');
                }
            } catch (error) {
                console.error("❌ Fatal Error:", error);
                if (spinner) spinner.classList.add('hidden');
                addToCartButton.classList.remove('loading');
            } finally {
                setTimeout(() => isIntercepting = false, 1000); 
            }
        },

        renderWidget: function(data) {
            this.removeWidget();
            const targetPlan = data.insurances.find(plan => plan.default_selected && plan.html_content) || data.insurances.find(plan => plan.html_content) || data.insurances[0];
            if (!targetPlan || !targetPlan.html_content) return;

            const bcpoContainer = document.querySelector('.best-custom-product-options') || document.getElementById('bcpo');
            const addToCartBtn = document.querySelector('button.product-form__submit[name="add"], button.add-to-cart, form[action*="/cart/add"] [type="submit"]');

            if (bcpoContainer) {
                bcpoContainer.insertAdjacentHTML('afterend', targetPlan.html_content);
            } 
            else if (addToCartBtn) {
                addToCartBtn.insertAdjacentHTML('beforebegin', targetPlan.html_content);
            } 
            else {
                const fallbackForm = document.querySelector('form[action*="/cart/add"]');
                if (fallbackForm) fallbackForm.insertAdjacentHTML('beforeend', targetPlan.html_content);
            }

            this.attachEventListeners(targetPlan, data);
        },

        attachEventListeners: function(plan, fullData) {
            const detailsLink = document.querySelector('.loxa-details-link');
            const addToCartButton = document.querySelector('button.product-form__submit[name="add"]');
            
            if (detailsLink && addToCartButton) {
                detailsLink.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!currentInsuranceData || !currentInsuranceData.insurable || !currentInsuranceData.active) return;
                    
                    const addToCartForm = addToCartButton.closest('form');
                    const bcpoForm = document.querySelector('.best-custom-product-options form');
                    this.openSidebar(fullData, addToCartButton, addToCartForm, bcpoForm, false); 
                });
            }

            const checkbox = document.getElementById('loxa-insurance-checkbox');
            if (checkbox) checkbox.addEventListener('change', () => hasSeenInsurancePrompt = true);
        },

        fetchInsurance: async function(totalPrice) {
            const productInfo = getBaseProductInfo(); 

            try {
                const params = new URLSearchParams({
                    product_sku: productInfo.sku,     
                    product_title: productInfo.title, 
                    product_price: totalPrice.toString()
                });                             

                const response = await fetch(`${CONFIG.proxyUrl}?${params}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                });

                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                const data = await response.json();
                
                // --- NEW LOGGING: Explicitly log the backend response ---
                if (CONFIG.debug) {
                    console.group("📥 Backend API Response");
                    console.log("Response Data:", data);
                    console.log("Insurable:", data.insurable);
                    console.log("Insurance Plans Found:", data.insurances ? data.insurances.length : 0);
                    console.groupEnd();
                }

                currentInsuranceData = data; 
                hasSeenInsurancePrompt = false; 

                if (data.insurable && data.active && data.insurances?.length > 0) {
                    this.renderWidget(data);
                } else {
                    if (CONFIG.debug) console.log("❌ Backend returned not insurable or inactive. Hiding widget.");
                    this.removeWidget();
                }

            } catch (error) {
                console.error("❌ Loxa Fetch Error:", error);
                this.removeWidget();
            }
        },

        findMatchingVariantId: async function(targetPrice) {
            try {
                if (!window.LoxaShopifyDev?.getInsuranceMap) return null;
                const insuranceMapArray = await window.LoxaShopifyDev.getInsuranceMap();
                for (const product of insuranceMapArray) {
                    if (!product.variants) continue;
                    const match = product.variants.find(v => Math.abs(parseFloat(v.price) - parseFloat(targetPrice)) < 0.01);
                    if (match) return match.id;
                }
                return null;
            } catch (e) { return null; }
        },

        interceptAddToCart: function() {
            const addToCartButton = document.querySelector('button.product-form__submit[name="add"], button.add-to-cart');
            if (!addToCartButton) return;

            addToCartButton.addEventListener('click', async (e) => {
                if (isIntercepting || !currentInsuranceData || !currentInsuranceData.insurable || !currentInsuranceData.active || !currentInsuranceData.insurances || currentInsuranceData.insurances.length === 0) {
                    return; 
                }

                const addToCartForm = addToCartButton.closest('form');
                const bcpoForm = document.querySelector('.best-custom-product-options form');
                
                let isBcpoValid = bcpoForm ? bcpoForm.checkValidity() : true;
                let isMainValid = addToCartForm ? addToCartForm.checkValidity() : true;

                if (!isBcpoValid || !isMainValid) {
                    e.preventDefault();
                    e.stopImmediatePropagation(); 
                    if (!isBcpoValid) bcpoForm.reportValidity();
                    else if (!isMainValid) addToCartForm.reportValidity();
                    return; 
                }

                const checkbox = document.getElementById('loxa-insurance-checkbox');
                
                if (checkbox && !checkbox.checked) {
                    if (!hasSeenInsurancePrompt) {
                        e.preventDefault();
                        e.stopImmediatePropagation(); 
                        LoxaController.openSidebar(currentInsuranceData, addToCartButton, addToCartForm, bcpoForm, true);
                        return; 
                    } else {
                        return; 
                    }
                }

                if (checkbox && checkbox.checked) {
                    e.preventDefault();
                    e.stopImmediatePropagation(); 
                    const targetPlan = currentInsuranceData.insurances.find(plan => plan.default_selected) || currentInsuranceData.insurances[0];
                    LoxaController.executeCartAdd(addToCartForm, bcpoForm, addToCartButton, targetPlan);
                }
            }, { capture: true }); 
        }
    };

    const calculateLiveTotal = () => {
        // ==========================================
        // 1. THE GATEKEEPER: Check if form is complete
        // ==========================================
        const bcpoContainer = document.getElementById('bcpo') || document.querySelector('.best-custom-product-options');
        const mainForm = document.querySelector('form[action*="/cart/add"]');

        let isComplete = true;

        if (mainForm && !mainForm.checkValidity()) {
            isComplete = false;
        }

        if (bcpoContainer && isComplete) {
            const requiredElements = bcpoContainer.querySelectorAll('select[required], input[required]');
            
            for (let el of requiredElements) {
                if (el.disabled) continue; 

                if (el.tagName === 'SELECT') {
                    if (!el.value || el.value === "") isComplete = false;
                } 
                else if (el.type === 'radio' || el.type === 'checkbox') {
                    const group = bcpoContainer.querySelectorAll(`input[name="${el.name}"]:not([disabled])`);
                    const isGroupChecked = Array.from(group).some(r => r.checked);
                    if (!isGroupChecked) isComplete = false;
                } 
                else {
                    if (!el.value || el.value.trim() === "") isComplete = false;
                }

                if (!isComplete) break; 
            }
        }

        if (!isComplete) {
            LoxaController.removeWidget();
            previousStateString = null;
            if (CONFIG.debug) console.log("⏳ Form incomplete. Waiting for user to finish required selections...");
            return;
        }

        // ==========================================
        // 2. THE CALCULATION (Only runs if complete)
        // ==========================================
        let finalTotal = 0;
        let basePrice = 0;
        let addonTotal = 0;
        const activeAddons = [];

        const activeVariantId = getActiveVariantId();
        
        if (window.ShopifyAnalytics?.meta?.product?.variants) {
            const activeVariant = window.ShopifyAnalytics.meta.product.variants.find(v => v.id.toString() === activeVariantId?.toString());
            if (activeVariant && activeVariant.price) {
                basePrice = activeVariant.price / 100; 
            }
        }

        if (basePrice === 0) {
            const priceEl = document.querySelector('.price-item--sale, .price-item--regular');
            if (priceEl && priceEl.innerText) {
                const rawText = priceEl.innerText.replace(/[^0-9.]/g, '');
                if (rawText) basePrice = parseFloat(rawText);
            }
        }

        const bcpoTotalElement = document.querySelector('.bcpo-addons-price');
        if (bcpoTotalElement && bcpoTotalElement.innerText) {
            const parsedAddon = parseFloat(bcpoTotalElement.innerText.replace(/[^0-9.]/g, ''));
            if (!isNaN(parsedAddon)) addonTotal = parsedAddon;
        }

        if (mainForm) {
            const formData = new FormData(mainForm);
            for (let [key, value] of formData.entries()) {
                if (key.startsWith('properties[') && value !== "") {
                    activeAddons.push({ Option: key, Choice: value });
                }
            }
        }

        finalTotal = basePrice + addonTotal;
        currentCalculatedTotal = finalTotal;

        // Fetch dynamic product info to capture active swatches (like Fabric Colors)
        const productInfo = getBaseProductInfo();

        // Include the dynamically generated SKU. 
        // This guarantees a fetch happens when the user clicks a new color, even if the price is identical.
        const currentStateString = JSON.stringify({ 
            price: finalTotal, 
            addons: activeAddons, 
            nativeVariantId: activeVariantId,
            dynamicSku: productInfo.sku
        });

        if (currentStateString !== previousStateString) {
            if (CONFIG.debug) {
                console.group("✅ Update Detected! Preparing Fetch...");
                console.log("Calculated Total:", finalTotal);
                console.log("Current Dynamic SKU:", productInfo.sku);
                console.log("Variant ID:", activeVariantId);
                console.groupEnd();
                
                console.log("📤 Requesting Insurance (Backend Check):", { 
                    sku: productInfo.sku, 
                    title: productInfo.title, 
                    price: finalTotal 
                });
            }
            previousStateString = currentStateString;
            LoxaController.fetchInsurance(finalTotal);
        }
    };

    const triggerCalculation = () => {
        clearTimeout(calcTimeout);
        calcTimeout = setTimeout(calculateLiveTotal, 250); 
    };

    const initObserver = () => {
        // 1. Hook into standard interactions AND BCPO inputs
        const triggerEvents = ['change', 'input'];
        triggerEvents.forEach(eventType => {
            document.addEventListener(eventType, (e) => {
                if (e.target.closest('variant-selects, variant-radios, form[action*="/cart/add"], #bcpo, .best-custom-product-options')) {
                    triggerCalculation();
                }
            });
        });

        // 2. Explicitly catch clicks on BCPO custom visual swatches (Images and Buttons)
        document.addEventListener('click', (e) => {
            if (e.target.closest('.bcpo-image-parent, .bcpo-button-parent, .bcpo-front-image-label, .bcpo-front-button-label, .swatch-view-item')) {
                // Delay allows BCPO's own internal script to check the hidden radio button first
                setTimeout(triggerCalculation, 150); 
            }
        });

        // 3. Hook into Shopify URL changes
        const originalReplaceState = history.replaceState;
        history.replaceState = function() {
            originalReplaceState.apply(this, arguments);
            triggerCalculation();
        };
        const originalPushState = history.pushState;
        history.pushState = function() {
            originalPushState.apply(this, arguments);
            triggerCalculation();
        };

        const targetNode = document.querySelector('product-form') 
                        || document.querySelector('.product-form')
                        || document.querySelector('.best-custom-product-options');

        if (!targetNode) {
            if (observerRetries < CONFIG.maxRetries) {
                observerRetries++;
                setTimeout(initObserver, 500); 
            }
            return;
        }

        const observer = new MutationObserver(triggerCalculation);
        
        const idInputs = document.querySelectorAll('input[name="id"]');
        idInputs.forEach(input => {
            observer.observe(input, { attributes: true, attributeFilter: ['value'] });
        });

        observer.observe(targetNode, { 
            childList: true,      
            subtree: true,        
            attributes: true,     
            attributeFilter: ['disabled', 'checked', 'value'] 
        });

        setTimeout(() => {
            LoxaController.interceptAddToCart();
            triggerCalculation();
        }, 500);
    };    

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
    } else {
        initObserver();
    }
})();